'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _CheckboxConstants = require('./CheckboxConstants');

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

var _underscore = require('../utils/underscore');

var _BrowserTest = require('../utils/BrowserTest');

var _DomEvents = require('../utils/DomEvents');

var _TabIndex = require('../utils/TabIndex');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _FieldsetContext = require('../context/FieldsetContext');

var _Checkable = require('../decorators/Checkable');

var _Checkable2 = _interopRequireDefault(_Checkable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderLabelText = function renderLabelText(ariaLabel, children, longhandSize) {
  if (children == null && !ariaLabel) {
    _devLogger2.default.warn({
      message: "UICheckbox: `aria-label` is required if you don't define `children`.",
      key: 'UICheckbox: aria-label required'
    });
  }

  if (children && ariaLabel) {
    _devLogger2.default.warn({
      message: 'UICheckbox: `aria-label` should not be used with `children`.',
      key: 'UICheckbox: aria-label & children'
    });
  }

  if (children == null) return null;

  return _react2.default.createElement(
    'span',
    {
      className: (0, _classNames2.default)('private-checkbox__text', {
        'private-checkbox__text--small': longhandSize === 'small'
      })
    },
    children
  );
};

var renderCheckmark = (0, _memoize2.default)(function () {
  return _react2.default.createElement(_UICheckmark2.default, { className: 'private-checkbox__icon__inner' });
});

var renderDash = (0, _memoize2.default)(function () {
  return _react2.default.createElement(
    'svg',
    {
      role: 'presentation',
      viewBox: '0 0 14 14',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement('path', {
      className: 'private-checkbox__icon__inner',
      d: 'M 2 6 L12 6 L12 9 L2 9 L2 6 z'
    })
  );
});

var renderIndicator = (0, _memoize2.default)(function (color) {
  return _react2.default.createElement(
    'span',
    { className: 'private-checkbox__indicator', style: { color: color } },
    _react2.default.createElement(
      'span',
      { className: 'private-checkbox__icon private-checkbox__check' },
      renderCheckmark()
    ),
    _react2.default.createElement(
      'span',
      { className: 'private-checkbox__icon private-checkbox__dash' },
      renderDash()
    )
  );
});

var UICheckbox = function (_Component) {
  _inherits(UICheckbox, _Component);

  function UICheckbox(props) {
    _classCallCheck(this, UICheckbox);

    var _this = _possibleConstructorReturn(this, (UICheckbox.__proto__ || Object.getPrototypeOf(UICheckbox)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleLabelClick = _this.handleLabelClick.bind(_this);
    return _this;
  }

  _createClass(UICheckbox, [{
    key: 'handleChange',
    value: function handleChange(evt) {
      var _props = this.props,
          disabled = _props.disabled,
          onChange = _props.onChange,
          readOnly = _props.readOnly;

      if (disabled || readOnly) {
        evt.preventDefault();
        return;
      }
      onChange(evt);
    }
  }, {
    key: 'handleLabelClick',
    value: function handleLabelClick(evt) {
      var _props2 = this.props,
          checked = _props2.checked,
          onChange = _props2.onChange;

      if ((0, _BrowserTest.isFirefox)() && (0, _DomEvents.isModifierPressed)(evt)) {
        onChange(_extends({}, evt, { type: 'change', target: { checked: !checked } }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          alignment = _props3.alignment,
          ariaLabel = _props3['aria-label'],
          ariaLabelledBy = _props3['aria-labelledby'],
          checked = _props3.checked,
          children = _props3.children,
          className = _props3.className,
          color = _props3.color,
          description = _props3.description,
          descriptionLayout = _props3.descriptionLayout,
          disabled = _props3.disabled,
          id = _props3.id,
          indeterminate = _props3.indeterminate,
          inline = _props3.inline,
          innerPadding = _props3.innerPadding,
          labelClassName = _props3.labelClassName,
          name = _props3.name,
          __onChange = _props3.onChange,
          readOnly = _props3.readOnly,
          size = _props3.size,
          tabIndex = _props3.tabIndex,
          value = _props3.value,
          rest = _objectWithoutProperties(_props3, ['alignment', 'aria-label', 'aria-labelledby', 'checked', 'children', 'className', 'color', 'description', 'descriptionLayout', 'disabled', 'id', 'indeterminate', 'inline', 'innerPadding', 'labelClassName', 'name', 'onChange', 'readOnly', 'size', 'tabIndex', 'value']);

      var computedDescId = description ? (0, _underscore.uniqueId)('checkbox-') : null;

      return _react2.default.createElement(
        _FieldsetContext.Consumer,
        null,
        function (_ref) {
          var fieldSize = _ref.size,
              fieldDisabled = _ref.disabled;

          var longhandSize = (0, _tshirtSize.toLonghandSize)(size || fieldSize);
          var computedDisabled = disabled || fieldDisabled;

          var wrapperClassName = (0, _classNames2.default)('private-checkbox', _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.PADDING_OPTIONS[innerPadding], _CheckboxConstants.SIZE_OPTIONS[longhandSize], {
            'private-checkbox--disabled': computedDisabled,
            'private-checkbox--readonly': readOnly,
            'private-checkbox--inline': inline,
            'private-checkbox--unlabeled': children == null,
            'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
          }, className);

          return _react2.default.createElement(
            'div',
            _extends({}, rest, { className: wrapperClassName }),
            _react2.default.createElement(
              'label',
              {
                className: (0, _classNames2.default)('private-checkbox__label', labelClassName),
                onClick: _this2.handleLabelClick
              },
              _react2.default.createElement(
                'span',
                { className: 'private-checkbox__inner' },
                _react2.default.createElement('input', {
                  'aria-describedby': computedDescId,
                  'aria-label': ariaLabel,
                  'aria-labelledby': ariaLabelledBy,
                  checked: checked,
                  className: (0, _classNames2.default)('private-checkbox__input sr-only', {
                    indeterminate: indeterminate
                  }),
                  disabled: computedDisabled,
                  id: id,
                  name: name,
                  onChange: _this2.handleChange,
                  readOnly: readOnly,
                  type: 'checkbox',
                  value: value,
                  tabIndex: (0, _TabIndex.getTabIndex)(readOnly || disabled, tabIndex)
                }),
                renderIndicator(color),
                renderLabelText(ariaLabel, children, longhandSize)
              )
            ),
            description && _react2.default.createElement(
              'span',
              { className: 'private-checkbox__desc', id: computedDescId },
              description
            )
          );
        }
      );
    }
  }]);

  return UICheckbox;
}(_react.Component);

UICheckbox.propTypes = {
  alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-label': _react.PropTypes.string,
  'aria-labelledby': _react.PropTypes.string,
  checked: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  color: _react.PropTypes.string,
  description: _react.PropTypes.node,
  descriptionLayout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
  disabled: _react.PropTypes.bool,
  indeterminate: _react.PropTypes.bool,
  inline: _react.PropTypes.bool,
  innerPadding: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.PADDING_OPTIONS)).isRequired,
  labelClassName: _react.PropTypes.string,
  name: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  readOnly: _react.PropTypes.bool,
  size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _react.PropTypes.oneOf(['default'])]),
  value: _react.PropTypes.any
};

UICheckbox.defaultProps = {
  alignment: 'start',
  checked: false,
  descriptionLayout: 'vertical',
  innerPadding: 'default'
};

UICheckbox.displayName = 'UICheckbox';

exports.default = (0, _Checkable2.default)(UICheckbox);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UICheckbox.js
// module id = 149
// module chunks = 3 4 5